import DiptychImageText from 'components/diptychImageText/DiptychImageText';
import PageHeader from 'components/page-header/PageHeader';
import modulesMap from 'core/modulesMap';
import MainPage from 'navigation/pages/MainPage';
class Brand extends MainPage {
    static pageName = 'Brand';
    getModulesMap() {
        return {
            ...modulesMap,
            pageHeader: ['.page-header', PageHeader],
            brandDiptychImageText: ['.brand-diptych-image-text', DiptychImageText]
        };
    }
}
export default Brand;
